import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import PrivateRoute from "components/external/privateroute/privateroute";
import { RouteType } from "./types";

import KeycloakPage from "pages/keycloakpage/keycloakpage";
import NoAccessPage from "pages/noaccesspage/noaccesspage";

import { routes } from "./routes";

export const Routes = ({ logged, userRoles }: RouteType) => {
    const isUserLogged: () => boolean = () => {
        return logged;
    };

    const generateRoutes = () => {
        if (Array.isArray(routes) && isUserLogged()) {
            return (
                <Switch>
                    {/* Private Routes */}
                    {Array.isArray(routes) &&
                        isUserLogged() &&
                        routes.map((route: any, index: number) => {
                            return (
                                <PrivateRoute
                                    key={"" + index}
                                    route={route}
                                    path={route.path}
                                    exact={route.exact}
                                    logged={logged}
                                    userRoles={userRoles}
                                />
                            );
                        })}
                    <Redirect from="*" to="/administration/" />
                </Switch>
            );
        } else {
            return (
                <Switch>
                    <Route
                        key="login-route"
                        path="/login/:module"
                        component={KeycloakPage}
                    />
                    <Route
                        key="login-route-2"
                        path="/:module/*"
                        component={KeycloakPage}
                    />
                    <Route
                        key="access-route"
                        path="/access/*"
                        component={NoAccessPage}
                    />
                    <Route
                        key="access-route2"
                        path="/access"
                        component={NoAccessPage}
                    />
                    <Redirect from="*" to="/administration/" />
                </Switch>
            );
        }
    };

    return <BrowserRouter>{generateRoutes()}</BrowserRouter>;
};

export default Routes;
